import { ONBOARDING_HOSTNAME } from '../../../env';

export const inviteMerchantPrefillUrl = (accountId: string) => {
    const partnerId = accountId.substr(1, 3);
    return `${ONBOARDING_HOSTNAME}/prefill?partner=${partnerId}`;
};
